var _polygon, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Finals_for_7.0",
    "data-name": "Finals for 7.0",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "104.24 80.87 67.49 80.87 67.49 44.12 73.64 44.12 73.64 74.72 104.24 74.72 104.24 80.87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0V144H144V0ZM6.14,6.13H137.86V137.85H6.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34,45.39l5.1,3.45A41.59,41.59,0,1,0,52.48,35.31l7,1.26-1.09,6-17-3.07,3.07-17,6,1.09L49.37,30A47.73,47.73,0,1,1,34,45.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.0d08facec6759637751aa1cbcee0a5aa.svg";
export { ForwardRef as ReactComponent };